import React, {FC} from 'react'
import {Modal, Button, Form, Spinner, Alert} from 'react-bootstrap'

type ModalImportDataProps = {
  show: boolean
  onHide: () => void
  onSubmit: () => void
  onFileChange: (file: File | null) => void
  isLoading: boolean
  error: string | null
}

const ModalImportData: FC<ModalImportDataProps> = ({
  show,
  onHide,
  onSubmit,
  onFileChange,
  isLoading,
  error,
}) => {
  return (
    <Modal show={show} centered>
      <Modal.Header>
        <Modal.Title>Import Trade Data</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Download the import template{' '}
          <a href='/template-import.csv' download>
            here
          </a>
          .
        </p>
        <Form.Group controlId='formFile'>
          <Form.Label>Upload File (.csv)</Form.Label>
          <Form.Control
            type='file'
            accept='.csv'
            onChange={(e) => {
              const target = e.target as HTMLInputElement
              onFileChange(target.files?.[0] || null)
            }}
            disabled={isLoading}
          />
        </Form.Group>
        {error && (
          <Alert variant='danger' className='mt-3'>
            {error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='default' className='btn-cancel' onClick={onHide}>
          Cancel
        </Button>
        <Button variant='primary' onClick={onSubmit} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              Importing...
            </>
          ) : (
            'Import'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalImportData
